import { useMutation } from 'react-query';

import { uploadXerFileVersions as mutationFn } from 'api/endPoints/uploadXerFileVersions';

import { Version } from 'components/common/UploadFileModal/components/programLibrary.types';

export const useMutationUploadXerFile = () => {
    return useMutation<any, QueryError, UploadXerPayload>({ mutationFn: (params) => mutationFn(params) });
};

export interface UploadXerPayload {
    projectId: number;
    contractId: number | null;
    contractName: string;
    versionId: string[];
    uploadingUser: string;
    isBaseline: boolean[];
    file: Blob;
    plf_file?: File | null;
    anotherFile?: File | null;
    versionName?: string;
    versionDate?: string;
    fileName: string;
    versions: Version[];
}
